module.exports = __webpack_public_path__ + "static/media/roble_detroit.8cc39902.jpg";